import Layout from "@/layout/index.vue";
import sharePage from './share.js';

export default [
  {
    name: "Layout",
    component: Layout,
    path: "/",
    redirect: "/",
    children: [
      {
        path: "/",
        name: "Home",
        component: () => import("@/views/majong/index.vue"),
        meta: {
          title: "激情麻将",
        },
      },
      // 用户协议
      {
        path: "/protocol.html",
        name: "protocol",
        component: () => import("@/views/majong/components/footer/Protocol.vue"),
      },
      // 隐私政策
      {
        path: "/privacy.html",
        name: "privacy",
        component: () => import("@/views/majong/components/footer/Privacy.vue"),
      },
    ],
  },
  // 404 页面
  {
    name: "404",
    path: "/:pathMatch(.*)*",
    hidden: true,
    component: () => import("@/components/exception/404.vue"),
    meta: {
      title: "404",
    },
  },
  ...sharePage
];
